export const seniorCustomerSupportResume = `
【職務概要】
2012年よりカスタマーサポート分野に従事し、13年にわたる経験を通じて顧客満足度向上と業務改善の専門スキルを磨いてきました。特に技術的な製品サポートとVOC（Voice of Customer）分析・活用に強みを持ち、サポート品質向上と業務効率化の両立に注力してまいりました。

8年間に渡り株式会社Algomaticシステムズでは、カスタマーサポート部門のマネージャーとしてチーム運営を行い、顧客の技術的課題を解決するだけでなく、そこから得られる情報を製品開発部門へフィードバックする体制を構築しました。これにより、製品不具合の34％削減と新機能追加による顧客満足度12ポイント向上を実現しました。近年はAIやチャットボットを活用したサポート業務の効率化と、グローバル対応の強化にも取り組んでいます。

技術の進化と顧客ニーズの多様化が進む中、顧客接点として得られる貴重な情報を企業全体の成長に繋げる「戦略的カスタマーサポート」の推進が、今後のビジネスにおいて重要な鍵になると考えています。

【職務経歴】
・株式会社Algomaticテクノロジー（2018年4月〜現在）
 ○ 会社概要：従業員数520名、ERPおよびビジネスインテリジェンスソフトウェア開発・販売
 ○ 職務内容：カスタマーサポート部 マネージャー（2020年4月より）
   - 18名のサポートスタッフをマネジメント
   - サポート対応プロセスの標準化・効率化
   - VOC（Voice of Customer）分析とその活用の仕組み構築
   - ナレッジベースの拡充とAIチャットボットの導入プロジェクト推進
   - 顧客向けトレーニングプログラムの設計と実施
 ○ 主な成果：
   - 顧客満足度調査で92%の高評価を維持（業界平均より15ポイント高い）
   - チケット解決時間を平均30%短縮
   - 顧客からのフィードバックを基に15件の機能改善を実現
   - AIチャットボット導入により一次回答の自動化率40%を達成
   - リモートサポート体制の確立により、コロナ禍でもサポート品質を維持
 ○ 使用技術・ツール：Zendesk、Tableau、SQL、JIRA、Confluence、Teams

・株式会社Algomaticシステムズ（2012年7月〜2018年3月）
 ○ 会社概要：従業員数180名、業務用データベースソフトウェア開発・販売
 ○ 職務内容：テクニカルサポート スペシャリスト → リーダー（2015年4月より）
   - 技術的な問い合わせへの電話・メール対応
   - 顧客サイトへの訪問サポート
   - サポートドキュメント・FAQの作成と管理
   - 新人サポートスタッフの教育・指導
 ○ 主な成果：
   - リピート問い合わせの28%削減
   - サポートナレッジベースの構築（800件以上の記事作成）
   - サポート対応満足度調査の導入と85%以上の高評価達成
   - 製品開発部門と連携した月次改善会議の立ち上げと運営
 ○ 使用技術・ツール：MySQL、SQL Server、Oracle DB、ServiceNow、Salesforce

・株式会社Algomatic産業（2010年4月〜2012年6月）
 ○ 会社概要：従業員数85名、工業用センサー機器製造・販売
 ○ 職務内容：営業サポート
   - 顧客からの製品問い合わせ対応
   - 納品管理と出荷手配
   - 営業資料の作成と管理
 ○ 主な成果：
   - 顧客データベースの整備と活用促進
   - 納期遅延の50%削減
   - 営業部と製造部の連携強化による顧客対応速度の向上
 ○ 使用技術・ツール：Excel、Access、社内顧客管理システム

【受賞・表彰歴】
・2023年 カスタマーサポートリーダーシップ賞（社内表彰）
・2022年 Best Support Team of the Year（株式会社Algomaticテクノロジー社内表彰）
・2020年 カスタマーサクセス推進プロジェクト功労賞
・2017年 顧客課題解決優秀事例 特別賞（技術系カスタマーサポート協会主催）
・2016年 サポート品質向上貢献賞（株式会社Algomaticシステムズ社内表彰）

【資格】
・ITサービスマネージメント技術者（ITIL Foundation）（2019年6月）
・プロジェクトマネジメント・プロフェッショナル（PMP）（2018年10月）
・オラクルマスター Gold（2016年5月）
・データベーススペシャリスト（2014年4月）
・Microsoft Certified: Azure Administrator Associate（2021年8月）

【マネジメント経験】
・カスタマーサポート部門（18名）のマネジメント経験 4年
・リモートワーク環境でのチーム運営、1on1ミーティングの定期実施
・新人育成プログラムの構築と実施（年間5名程度の新人教育）
・部門横断プロジェクト（AI導入、顧客満足度調査分析など）のリーダー経験
・顧客向けトレーニングセミナーの企画・実施（年間10回以上、延べ500名以上）
・主な成果：離職率50%削減、チーム全体の顧客評価スコア15%向上

【語学力】
・英語：ビジネスレベル（TOEIC 820点）
 ○ 海外顧客からの技術問い合わせ対応
 ○ 社内グローバルミーティングでのプレゼンテーション
 ○ 技術文書・マニュアルの英文レビュー
・中国語：日常会話レベル
 ○ 中国顧客との基本的なコミュニケーション
` as const;
